'use client'

import { Spinner } from '@src/components/Spinner/Spinner'

export function QuizLoadingFallback() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-bodi-black">
      <Spinner size="large" className="size-16 fill-bodi-accent-bright-500" />
    </div>
  )
}
